import React from 'react';
import { FreeHeaderTable } from './FreeHeaderTable';
import { FrozenHeaderTable } from './FrozenHeaderTable';
export var Table = function Table(props) {
  return React.createElement(React.Fragment, null, props.frozenHeaders && React.createElement(FrozenHeaderTable, Object.assign({}, props)), !props.frozenHeaders && React.createElement(FreeHeaderTable, Object.assign({}, props)));
};